import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { IOwnershipUser } from '@fi-app/other-settings/transfer-ownership/fi-transfer-ownership';
import { ObjectTypes } from '@fi-shared/types';

@Component({
    selector: 'fi-transfer-ownership-completed-card',
    template: `
        <mat-card class="transfer-ownership-card completed-card">
            <mat-card-title>
                <mat-icon class="far fa-transporter BrandedColor title-icon" />
                <span>{{ 'ownership.completed_section' | fiAppText }}</span>
            </mat-card-title>
            <mat-card-content>
                <p
                    class="transfer-ownership-card_content-text"
                    [innerHTML]="
                        'ownership.completed_section_description'
                            | fiAppText: { '{0}': sourceUser.FullName, '{1}': targetUser.FullName }
                    "
                ></p>

                <fi-transfer-ownership-summary-data
                    [sourceUser]="sourceUser"
                    [targetUser]="targetUser"
                    [sourceUserAreaName]="sourceUserAreaName"
                    [targetUserAreaName]="targetUserAreaName"
                    [selectedObjectTypes]="selectedObjectTypes"
                    [isCompleted]="true"
                />
            </mat-card-content>
        </mat-card>
    `,
    styleUrl: './fi-transfer-ownership-completed-card.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-transfer-ownership-completed-card' },
    standalone: false,
})
export class FiTransferOwnershipCompletedCardComponent {
    @Input({ required: true }) sourceUser: IOwnershipUser;
    @Input({ required: true }) targetUser: IOwnershipUser;
    @Input({ required: true }) selectedObjectTypes: ObjectTypes[];
    @Input({ required: true }) sourceUserAreaName: string;
    @Input({ required: true }) targetUserAreaName: string;
}
